module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-peanuts.4f6d8c90.svg";